import { Component, Input } from "@angular/core";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from "ag-grid-community";
import { AccountManualType } from "@bitwarden/web-vault/app/models/types/account.types";
import {
  accountTypeIcon,
  localBasiqLogoPath,
} from "@bitwarden/web-vault/app/models/types/account-display.utils";
import { InstitutionService } from "@bitwarden/web-vault/app/services/DataService/institution/institution.service";

@Component({
  selector: "app-account-icon-renderer",
  templateUrl: "./account-icon-renderer.component.html",
})
export class AccountIconRendererComponent implements ICellRendererAngularComp {
  defaultIcon: AccountManualType = "bank";
  icon = "";
  square_logo_url = "";
  full_logo_url = "";
  @Input() useManageAccountStyle = false;
  /** The 36px tile with a 26px rounded-square logo (Accounts list cards, details hero). */
  @Input() large = false;
  // data accepts either an account-like object (ag-grid / manage account) or an
  // institution name string, in which case logos are resolved via InstitutionService.
  @Input() set data(
    value: string | { type?: string; square_logo_url?: string; full_logo_url?: string },
  ) {
    if (!value) {
      return;
    }
    if (typeof value === "string") {
      const inst = this.institutionService
        .getInstitutionsMasterList()
        .find((i) => i.name?.toLowerCase() === value.toLowerCase());
      this.icon = this.defaultIcon;
      this.square_logo_url = localBasiqLogoPath(inst?.square_logo_url ?? "");
      this.full_logo_url = inst?.full_logo_url ?? "";
      return;
    }
    this.icon = accountTypeIcon(value.type);
    this.square_logo_url = localBasiqLogoPath(value.square_logo_url ?? "");
    this.full_logo_url = value.full_logo_url ?? "";
  }

  constructor(private institutionService: InstitutionService) {}

  agInit(params: ICellRendererParams): void {
    this.icon = accountTypeIcon(params.data?.type);
    this.square_logo_url = localBasiqLogoPath(params.data?.square_logo_url);
    this.full_logo_url = params.data?.full_logo_url;
  }

  refresh(params: ICellRendererParams): boolean {
    this.icon = accountTypeIcon(params.data?.type);
    return true;
  }
}
